import getYears, { GetYearsOptions } from 'api/vehicles/getYears'
import useSWR from 'swr'

export default function useVehicleYears(options: GetYearsOptions | null) {
    let key: readonly ['vehicle-years', GetYearsOptions] | null = null

    if (options) {
        key = ['vehicle-years', options]
    }

    // SWR owns this shared request; one consumer must not abort it for others.
    return useSWR(key, ([, queryOptions]) => getYears(queryOptions), {
        keepPreviousData: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        shouldRetryOnError: false,
    })
}
